import {useMutation} from '@apollo/client'
import React, {useEffect} from 'react'
import {Button, Modal, Spinner} from 'react-bootstrap'
import {toast} from 'react-toastify'
import {parseId} from '../../../helpers'
import { DELETE_USER_DEDUCTION } from '../../../gql/mutations/userMutations'
import { IResDeleteCommissionUserDeduction } from '../../../types/users'
import {FormattedMessage, useIntl} from 'react-intl'
import {ONE_USER_MESSAGES as M} from '../oneUserMessages'

interface IModalDeleteDeductionProps {
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  infoEdit: {id: string}
}

export const ModalDeleteDeduction: React.FC<IModalDeleteDeductionProps> = ({
  infoEdit,
  isOpen,
  onClose,
  refetch,
}) => {
  const intl = useIntl()
  const [gqlDeleteCommissionRate, {data, loading, error}] =
    useMutation<IResDeleteCommissionUserDeduction>(DELETE_USER_DEDUCTION)

  useEffect(() => {
    if (error)
      toast.error(
        intl.formatMessage(
          {id: 'common.error.withMessage', defaultMessage: 'Error: {message}'},
          {message: error.message}
        )
      )
  }, [error])

  useEffect(() => {
    if (!data) return

    const res = data.CommissionUserDeductionDelete

    if (res?.success) {
      toast.success(intl.formatMessage(M.toastDeductionDeleted))
      onClose()
      refetch()
    } else if (res?.errors && res.errors.length > 0) {
      toast.error(
        intl.formatMessage({id: 'common.error.withMessage', defaultMessage: 'Error: {message}'}, {
          message: res.errors[0]?.message || intl.formatMessage({id: 'common.error.somethingHappened', defaultMessage: 'Something happened'}),
        })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleDelete = () => {
    gqlDeleteCommissionRate({
      variables: {
        id: parseId(infoEdit.id),
      },
    })
  }
  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage {...M.deductionDeleteTitle} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4 className='text-primary'>
          <FormattedMessage {...M.deductionDeleteBody} />
        </h4>
      </Modal.Body>
      <Modal.Footer>
        <Button size='sm' variant='secondary' onClick={onClose}>
          <FormattedMessage id='common.action.cancel' defaultMessage='Cancel' />
        </Button>
        <Button
          size='sm'
          variant='danger'
          className='d-flex align-items-center'
          disabled={loading}
          onClick={handleDelete}
        >
          {loading && <Spinner animation='border' size='sm' />}
          <FormattedMessage id='common.action.delete' defaultMessage='Delete' />
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
